import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createDivision,
  deleteDivision,
  getDivision,
  updateDivision,
} from "libs/api/division";

// Division Thunk
export const getDivisionThunk = createAsyncThunk(
  "division/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getDivision(pathname, queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Create Division Thunk
export const createDivisionThunk = createAsyncThunk(
  "division/create",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createDivision(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Update Division Thunk
export const updateDivisionThunk = createAsyncThunk(
  "division/update",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,

    body,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateDivision(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Delete Division Thunk
export const deleteDivisionThunk = createAsyncThunk(
  "division/delete",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteDivision(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);
